var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUsLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 110,
    viewBox: "0 0 117 110",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4468 62.2607C99.6592 56.864 106.624 50.8332 115.295 47.9303C115.811 47.7557 116.091 47.1988 115.92 46.6807C115.745 46.165 115.188 45.8848 114.67 46.0563C105.797 49.0278 98.6429 55.1569 91.2637 60.6799C90.8257 61.0043 90.7374 61.6263 91.0649 62.0619C91.3893 62.4999 92.0089 62.5851 92.4468 62.2607Z",
    fill: "url(#paint0_linear_912_425)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7314 52.4839C84.341 48.7185 85.5527 45.3036 87.8705 42.2605C88.2019 41.826 88.1169 41.2072 87.6853 40.8756C87.2506 40.5465 86.6296 40.6317 86.3013 41.0637C83.7805 44.3725 82.4477 48.0739 81.7842 52.1666C81.6956 52.7054 82.0603 53.2137 82.5999 53.2996C83.1363 53.3875 83.646 53.0202 83.7314 52.4839Z",
    fill: "url(#paint1_linear_912_425)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1561 35.1488C58.4402 30.8855 58.2986 26.6058 59.8112 22.2451C59.9893 21.7308 59.7169 21.1675 59.2008 20.9903C58.6878 20.8106 58.1243 21.0841 57.9462 21.5984C56.2731 26.4254 56.4249 31.1651 58.3247 35.8857C58.5268 36.3917 59.1051 36.6351 59.6089 36.4327C60.116 36.2281 60.3614 35.6524 60.1561 35.1488Z",
    fill: "url(#paint2_linear_912_425)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5948 57.8648C21.55 59.0468 21.6105 60.2348 21.7905 61.4088C21.8703 61.9317 22.1152 62.9837 22.578 63.6871C23.0685 64.4384 23.7736 64.8432 24.6336 64.6721C25.7753 64.4441 26.393 63.8884 26.6987 63.2426C26.9937 62.6213 27.0005 61.851 26.741 61.0294C26.2445 59.4595 24.7203 57.6622 23.6506 56.7939C23.7715 55.6258 24.0031 54.4707 24.3369 53.3432C26.8231 44.9457 36.216 39.9329 47.236 40.8968C51.0934 41.2351 55.6023 44.7708 59.8709 49.0545C66.5181 55.7238 72.4821 64.3213 74.3056 66.7802C74.7573 67.3863 75.0904 67.6949 75.1768 67.7409C75.5951 67.9725 75.9234 67.8599 76.1302 67.7525C76.4275 67.594 76.5963 67.3808 76.6955 67.1621C76.8283 66.8648 76.8496 66.5086 76.6819 66.1166C76.5878 65.9012 76.4045 65.6426 76.1896 65.3822C76.0386 65.2031 75.8432 65.0313 75.7767 64.8701C75.3544 63.8351 74.9973 62.7808 74.6294 61.7256C73.3856 58.1839 72.5592 54.598 71.8718 50.908C69.6867 39.1834 66.9891 27.1011 69.1398 15.1672C69.2361 14.6318 68.881 14.1165 68.3437 14.0208C67.8094 13.9227 67.2961 14.2792 67.197 14.8173C65.0019 26.9885 67.7036 39.3123 69.9311 51.2696C70.5163 54.4083 71.2001 57.4744 72.1444 60.5013C68.994 56.3109 64.4745 50.6352 59.7518 46.1828C55.5519 42.2226 51.1572 39.2601 47.4075 38.931C35.3356 37.8749 25.1655 43.5855 22.4445 52.7829C22.1538 53.767 21.9307 54.7733 21.7852 55.7888C13.997 52.5094 5.27636 55.5991 1.37412 63.167C1.12299 63.6523 1.31454 64.2471 1.79773 64.4974C2.28403 64.7453 2.87849 64.556 3.12962 64.0706C6.64611 57.2512 14.6256 54.5922 21.5948 57.8648ZM23.5748 59.4562C23.6027 60.0089 23.6595 60.56 23.7415 61.1113C23.7873 61.4058 23.8974 61.9546 24.1158 62.4046C24.168 62.5092 24.2757 62.6525 24.327 62.7177C24.6241 62.6548 24.8316 62.5739 24.9142 62.3979C25.0185 62.1793 24.9492 61.9123 24.8585 61.6246C24.6316 60.9019 24.1195 60.1103 23.5748 59.4562Z",
    fill: "url(#paint3_linear_912_425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_912_425",
    x1: 90.4688,
    y1: 61.3047,
    x2: 96.4144,
    y2: 67.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_912_425",
    x1: 77.8437,
    y1: 47.6757,
    x2: 88.5671,
    y2: 53.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_912_425",
    x1: 51.1094,
    y1: 26.7773,
    x2: 67.2207,
    y2: 29.3238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_912_425",
    x1: 0,
    y1: 62.3554,
    x2: 71.6007,
    y2: 100.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsLines);
export default __webpack_public_path__ + "static/media/ContactUsLines.6ae67ff278610fa61ac0dd460ce6cbd6.svg";
export { ForwardRef as ReactComponent };